import { createProviderClass } from '@core/common-legacy';
import type { WalkthroughStepId, WalkthroughStepOrigin } from '@core/walkthrough-types';

export abstract class WalkthroughRegisterContract {
  public abstract register: (stepId: WalkthroughStepId, origin: WalkthroughStepOrigin) => void;
  public abstract unregister: (stepId: WalkthroughStepId) => void;
}

export const { inject: injectWalkthroughRegister, provide: provideWalkthroughRegister } =
  createProviderClass(WalkthroughRegisterContract)();
